export const illustrationUrl =
  'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1773759077/corp-management-ui/balance/Group%20Order%20Illustration_png.png';

export const wizardStepEnterDuration = 500;
export const wizardStepExitDuration = 1000;

export const defaultWizardStepStyles = {
  transition: `all ${wizardStepEnterDuration}ms ease-in`,
  opacity: 0,
} as const;

export const wizardStepTransitionStyles = {
  entering: {
    opacity: 1,
  },
  entered: {
    opacity: 1,
  },
  exiting: {
    opacity: 0,
  },
  exited: {
    opacity: 0,
  },
} as const;

export const FIXED_FOOTER_HEIGHT = '68px';

const SIGNUP_WIZARD_FIXED_HEADER_Z_INDEX = 10;
const FIXED_FOOTER_Z_INDEX = SIGNUP_WIZARD_FIXED_HEADER_Z_INDEX + 1;

export const phoneFixedFooterProps = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: FIXED_FOOTER_Z_INDEX,
} as const;
